import { render } from "./DataBlends.vue?vue&type=template&id=0527b3c6"
import script from "./DataBlends.vue?vue&type=script&lang=js"
export * from "./DataBlends.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/DataBlends.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0527b3c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0527b3c6', __exports__)) {
    api.reload('0527b3c6', __exports__)
  }
  
  module.hot.accept("./DataBlends.vue?vue&type=template&id=0527b3c6", () => {
    api.rerender('0527b3c6', render)
  })

}


export default __exports__